import React, { useEffect, useContext, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { AppContext, DispatchContext } from "../AppContext";
import Service from "../services/service";
import * as actions from "../actions/actions";
import { showCaptcha, config, resolveNotificationMessage } from '../helpers/constants';
import { Box, Paper, Typography, Button } from "@material-ui/core";
import FullScreenPage from "./FullScreenPage";
import LicenseQuotePanel from './LicenseQuotePanel';
import DividerLabel from "./DividerLabel";
import { ReactComponent as CheckedIcon } from '../assets/icons/checked.svg';
import LoadingScreen from "./LoadingScreen";
import PaymentDialog from "../components/PaymentDialog";


const useStyles = makeStyles((theme) => ({
    paper: {
        width: 850,
        minHeight: 500,
        position: "relative",
        boxShadow: "0px 0px 5px 5px rgba(0, 0, 0, 0.25)",
        "&:hover": {
            boxShadow: "0px 0px 7px 7px rgba(0, 0, 0, 0.4)",
            transition: "box-shadow 0.3s ease-in-out",
        }
    }
}));

export default function Shop(props) {
    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles();
    const [quoteSent, setQuoteSent] = useState(false);
    const { prodId, origin } = useParams();

    useEffect(() => {
        if (!state.user.loggedIn) {
            showCaptcha();
        }
        dispatch(actions.openPaymentDialog(true));
    }, []);

    const captchaAction = (action, fn) => {
        const captchas = document.getElementsByClassName("grecaptcha-badge");
        if (captchas.length > 0 && captchas[0].style.visibility != "hidden") {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(config.captchaKey, { action: action }).then(function (token) {
                    Service.verifyReCaptcha(token).then((verifyRes) => {
                        if (verifyRes.success) {
                            fn();
                        } else {
                            dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(verifyRes.errors[0], s.notificationMessage) }));
                        }
                    });
                });
            });
        } else {
            fn();
        }
    }

    const doGuestLogin = () => {
        Service.createGuestUser().then(res => {
            if (res.success) {
                Service.getUserInfo().then(getInfoRes => {
                    dispatch(actions.setUserDetails(getInfoRes.data));
                    dispatch(actions.showFullscreenLoading(false));
                });
            } else {
                dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage), status: true }));
            }
        });
    }

    const onCancelButtonClicked = () => {
        // real redirect to get rid of Captcha script

        var originId = parseInt(origin);
        switch (originId) {
            case 0:
                window.location.href = config.backendUrl + s.links.prepaid;
                break;
            case 1:
                window.location.href = config.backendUrl + s.links.volumeLicense;
                break;
            case 2:
                window.location.href = config.backendUrl + s.links.eduLicense;
                break;
            case 3:
                window.location.href = config.backendUrl + s.links.appStudents;
                break;
            case 4:
                window.location.href = config.backendUrl + s.links.plansOverview;
                break;
            default:
                window.location.href = config.backendUrl + s.links.home;
        }
    }

    const onQuoteSent = () => {
        setQuoteSent(true);
    }




    return (
        <FullScreenPage>
            {!quoteSent &&
                <PaymentDialog
                    disableBackdrop={true}
                    onClose={(tab) => onCancelButtonClicked(tab)}
                    onQuoteSent={() => onQuoteSent()}
                    preselectedProductId={parseInt(prodId) || 0}
                />}
            {quoteSent &&

                <Paper elevation={5} className={classes.paper}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", padding: 60 }}>
                        <Box mt={2} />
                        <CheckedIcon style={{ fill: '#009900' }} height={100} width={100} />
                        <Box mt={4} />
                        <Typography paragraph variant="h6">{s.paymentDialog.thanksForQuoteRequest}</Typography>
                        <Typography align="center" color="secondary">{s.paymentDialog.thanksForQuoteRequestText}</Typography>
                        <Box mt={4} />
                        <Button onClick={onCancelButtonClicked} variant="outlined" style={{ marginLeft: 8 }}>{s.common.close}</Button>
                    </div>
                </Paper>
            }
        </FullScreenPage>
    );
}
